<div class="editor-container">
  <tiptap-editor class="editor" [editor]="editor" [(ngModel)]="value"> </tiptap-editor>
</div>
